import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class SurveyAuthService {
  isLoggedIn = false;

  constructor(private http: HttpClient, private router: Router) {
    // let token = localStorage.getItem('auth.surveyToken');
    // if (token) token = JSON.parse(token);
    // if (token !== null) {
    //   this.isLoggedIn = true;
    // }
  }

  logIn(username: string, password: string) {
    const post_url = environment.surveyApiHost + '/api-auth/get-token';
    console.log('POST to ' + post_url);
    let headers = new HttpHeaders();
    headers = headers.append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    const credentials = 'username=' + username + '&password=' + password;

    console.log('credentials: ' + credentials);
    return (
      this.http
        .post(post_url, credentials, { headers: headers })
        .map(this.extractToken)
        // .map(this.markAsLoggedIn(this))
        .catch(this.handleError)
    );
  }

  authenticateWithToken(token: string) {
    const post_url =
      environment.surveyApiHost + '/api-auth/get-token-from-jwt-token';
    console.log('POST to ' + post_url + ' with token ' + token);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return (
      this.http
        .post(post_url, { token: token }, { headers: headers })
        .map(this.extractToken)
        // .map(this.markAsLoggedIn(this))
        .catch(this.handleError)
    );
  }

  private markAsLoggedIn(context) {
    return () => {
      context.isLoggedIn = true;
    };
  }

  private extractToken(res: any) {
    console.log('extractToken, res', res);
    return res.token;
  }

  private handleError(error: any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(errMsg); // log to console
    return throwError(error);
  }

  logOut() {
    localStorage.removeItem('auth.surveyToken');
    this.isLoggedIn = false;
    return true;
  }

  public token(): string {
    return JSON.parse(localStorage.getItem('auth.surveyToken'));
  }
}
